// © Microsoft Corporation. All rights reserved.

import { applyLocalizedProperty, toPx } from "@microsoft/fast-jss-utilities";
import {
    highContrastSelected,
    neutralFillActive,
    neutralFillHover,
    neutralFillRest,
    neutralOutlineActive,
    neutralOutlineHover,
    neutralOutlineRest
}
    from "@microsoft/fast-components-styles-msft";

import { CardContextMenuClassNameContract } from "./CardContextMenu.classnames";
import { ComponentStyles } from "@microsoft/fast-jss-manager";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";

export const CardContextMenuStyles: ComponentStyles<CardContextMenuClassNameContract, DesignSystem> = (config: DesignSystem) => {
    return {
        settingButton: {
            height: "100%",
            width: "100%",
            border: "none",
            background: "none",
            cursor: "pointer",
            outline: "none",
            padding: "0",

            "&:focus": {
                border: `${toPx(config.outlineWidth)} dotted`,
                "border-color": neutralOutlineActive
            }
        },
        settingButtonIcon: {
            fill: neutralOutlineHover,
            height: "24px",
            width: "24px"
        },
        contextMenuItem: {
            display: "flex",
            cursor: "pointer",
            border: `${toPx(config.outlineWidth)} solid transparent`, // Reserve space for hover border
            height: "30px",
            margin: "0",
            padding: `0px 12px 0px`,
            "user-select": "none",
            "&:focus, &:hover": {
                background: neutralFillHover,
                "border-color": neutralOutlineHover,
                ...highContrastSelected
            },
            "&:active": {
                background: neutralFillActive
            }
        },
        contextMenuItem_contentRegion: {
            display: "flex",
            "align-items": "center"
        },
        contextMenuItem_image: {
            [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "8px"
        },
        contextMenu: {
            "box-shadow": "none",
            padding: "0",
            width: "145px",
            background: neutralFillRest,
            border: `${toPx(config.outlineWidth)} solid`,
            "border-color": neutralOutlineRest
        }
    };
};